import { useSelector } from 'react-redux';
import config from '../../../config';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../../marketplace-custom-config';
import { isProfileComplete } from '../../../util/user';
import { getOwnListingsById } from '../../../containers/ManageListingsPage/ManageListingsPage.duck';

const { userTypeRider } = config;

/**
 * Notification dots shown in the navigation (Topbar, BottomBarMobile), derived from the store.
 */
export const useTopbarIndicators = () => {
    const isAuthenticated = useSelector(s => s['Auth'].isAuthenticated);
    const currentUser = useSelector(s => s['user'].currentUser);
    const unreadMessagesRider = useSelector(s => s['user'].currentUserUnreadMessagesRider);
    const unreadMessagesOwner = useSelector(s => s['user'].currentUserUnreadMessagesOwner);
    const hasDraftListing = useSelector(s =>
        (getOwnListingsById(s, s['ManageListingsPage'].currentPageResultIds) || []).some(
            listing => listing?.attributes?.state === 'draft'
        )
    );

    const { userType, availabilityStatus } = currentUser?.attributes?.profile?.publicData || {};
    const userIsRider = userType === userTypeRider;

    const { isPrimaryFieldsComplete } =
        userIsRider && currentUser ? isProfileComplete(currentUser) : {};

    const profileNotComplete =
        userIsRider &&
        (!isPrimaryFieldsComplete || availabilityStatus === RIDER_AVAILABILITY_NOT_AVAILABLE);

    const notificationCount =
        isAuthenticated && (userIsRider ? unreadMessagesRider : unreadMessagesOwner);

    return { profileNotComplete, notificationCount, hasDraftListing };
};
